import { Box, Button, Container, Typography } from "@mui/material";
// import content from "content/BookDemo";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const imageUrl =
  "https://s3-alpha-sig.figma.com/img/88ff/5353/13fa6f5bdfb2195cb09f7fda24cd5ee5?Expires=1739145600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=qdS6e4T1tHRO1txamiBZXa5I2p2wmYZ-qNZxLPElGFwIDfXsnQ37l9fayF~qZUjpQuBE8ALvdx7EUEiUI7AKKR78Ca~0UtYpQF-z~in4O7KnauF-COCBL2KPtkd0AK3uLvUZ2gNBobhmb~3bOe4keuoNXC7aDAj6pGDf6z35dnsOIShdPo9RW-XCHrQyYkfpVtpuYc74FwNfPyA7kl9m0CQWiW9cuVxF-cHfoP-hJWJgHBuWOmvM9r858XKoyQB3Fe5YXyxmsR9LOsGW38fXYi80HlzstJ3VxKuf6x2QDz2BlAUhEgMrLdsCK21d4tYCWhXs76KuWzNAUwZGtsnK~g__";
export default function BookDemo() {
  const navigate = useNavigate();
  const handleBookDemo = () => {
    navigate("/contact");
  };

  const [content, setContent] = useState({});

  useEffect(() => {
    const funct = async () => {
      const res = await fetch("https://cms.xane.ai/api/book-demos");
      const response = await res.json();
      setContent(response.data[0]);
    };

    funct();
  }, []);

  return (
    <Container>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          alignSelf: "stretch",
          borderRadius: { xs: "20px", sm: "40px", md: "40px" },
          // background: `url(${imageUrl}) lightgray -5.269px 0px / 100.878% 100% no-repeat`,
          background: `linear-gradient(154deg, rgba(72,151,182,0.9) 0%, rgba(230,98,8,0.9) 78%, rgba(223,168,109,1) 180%);`,

          height: {
            xs: "361px",
            sm: "420px",
            md: "464px",
          },
          padding: {
            xs: "0px 36px",
            sm: "20px",
            md: "0px 10px",
          },
          gap: {
            xs: "48px",
            sm: "36px",
            md: "56px",
          },
        }}
      >
        <Box
          sx={{
            // width: "80%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            alignSelf: "stretch",
            gap: { xs: "24px", sm: "12px", md: "36px" },
          }}
        >
          <Typography
            sx={{
              color: "#FEFFFF",
              textAlign: "center",
              fontFamily: "Inter",
              fontSize: { xs: "23px", sm: "33px", md: "48px" },
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: 1.4,
              width: { xs: "100%", sm: "80%", md: "80%" },
            }}
          >
            {content?.heading}
          </Typography>
          <Typography
            sx={{
              color: "#EBF5F9",
              textAlign: "center",
              textShadow: "0px 8px 24px rgba(78, 100, 122, 0.15)",
              fontFamily: "Inter",
              fontSize: { xs: "16px", sm: "19px", md: "23px" },
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: 1.4,
            }}
          >
            {content?.description}
          </Typography>
        </Box>

        <Button
          variant="contained"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,
            borderRadius: "30px",
            border: "2px solid #FFF",
            background: "linear-gradient(180deg, #0E0E0E 0%, #333 100%)",
            boxShadow: "0px 14px 30px 0px rgba(0, 0, 0, 0.12)",
            textTransform: "capitalize",
            color: "#fff",
            fontFamily: "Inter",
            fontSize: { xs: "13px", sm: "16px", md: "19px" },
            fontWeight: 600,
            lineHeight: 1.4,

            width: {
              xs: "260px",
              sm: "220px",
              md: "220px",
            },
            height: {
              xs: "44px",
              sm: "64px",
              md: "64px",
            },
            padding: {
              xs: "10px 24px",
              sm: "10px 24px",
              md: "10px 24px",
            },
          }}
          onClick={handleBookDemo}
        >
          {content?.buttonText}
        </Button>
      </Box>
    </Container>
  );
}
